"use client";

import type { ReactElement } from "react";
import { Cchatteaser3Content } from "@/components/ui/Cchatteaser3";
import { CfooterContent } from "@/components/ui/Cfooter";
import { Chero } from "@/components/ui/Chero";
import { Cpagelayout } from "@/components/ui/Cpagelayout";
import { CwitnessContent } from "@/components/ui/Cwitness";
import { NAVBAR_HEIGHT } from "@/constants/componentPresets";
import type { HomePageControllerLocal } from "./domain/home-page/types";
import { LandingDeferredSection } from "./LandingDeferredSection";
import { useGalleryChunkPreload } from "./useGalleryChunkPreload";

interface LandingPageContentProps {
  controller: HomePageControllerLocal;
}

export function LandingPageContent({
  controller,
}: LandingPageContentProps): ReactElement {
  useGalleryChunkPreload();

  return (
      <Cpagelayout
        dataElScope="LandingPageContent/Layout"
        profileImageSrc={controller.profileImageSrc}
        showNonLoggedNavbar={controller.showNonLoggedNavbar}
        authLoading={controller.shouldHideNavbar}
        authError={controller.hasProfileError}
        onPricingClick={controller.handlePricingClick}
        onAuthorizeClick={controller.handleAuthorizeClick}
        useBlackBackground={true}
        isLandingPage={true}
        onStartNewSession={controller.handleStartNewSession}
        onReplicateTeam={controller.handleReplicateTeam}
        openUserMenuRequestId={controller.openUserMenuRequestId}
      >
        <Chero
          onTeamDetailsOpen={controller.handleHeroTeamDetailsOpen}
          onTeamDeploy={controller.handleHeroTeamDeploy}
          onBuildYourOwn={controller.handleBuildYourOwnTeam}
          onAllTeams={controller.handleAllTeamsClick}
          onQuickStart={controller.handleQuickStart}
        />
        <LandingDeferredSection
          name="chatTeaser"
          style={{ paddingTop: NAVBAR_HEIGHT }}
        >
          {() => (
            <Cchatteaser3Content fillParent />
          )}
        </LandingDeferredSection>
        <LandingDeferredSection name="witness">
          {(sectionRef) => (
            <CwitnessContent sectionRef={sectionRef} />
          )}
        </LandingDeferredSection>
        <LandingDeferredSection name="footer">
          {(sectionRef) => (
            <CfooterContent
              sectionRef={sectionRef}
              onContactClick={controller.handleContactClick}
              onRevealEmailClick={controller.handleRevealEmailClick}
              onAboutUsClick={controller.handleAboutUsClick}
            />
          )}
        </LandingDeferredSection>

        {/* "Start new session" mounts nothing here: it opens the app-level
            session-start chooser overlay (no blank deploy exists — ruled
            2026-08-29). "Build Your Own" likewise mounts nothing: it opens
            the canonical team modal on an EMPTY subject with edit invoked,
            and the created team lands in its regular state inside that same
            open modal. */}
      </Cpagelayout>
  );
}
